// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__NBjib","form":"styles_form__TjeEu"};